export default __webpack_public_path__ + "static/media/track-customer.886b06a1.png";